import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { FileUploadService } from '@app/services/fileUpload.service';
import { JobDescriptionService } from '@app/services/jobDescription.service';
import { JobDescriptionDocument } from '@app/model/jobDescriptionDocument';
import { JobDescription } from '@app/model/jobDescription';
import { FileUpload } from '@app/model/fileUpload';
import { MessageService } from 'primeng/api';
import { NgForm, ControlContainer } from '@angular/forms';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Messages } from '@app/constants/constant';
import { IfStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { JdSearchService } from '@app/services/jdSearch.service';
import { JobDescriptionDocumentService } from '@app/services/jobDescriptionDocument.service';

@Component({
  selector: 'job-description-modal',
  templateUrl: './job-description-modal.component.html',
  styleUrls: ['./job-description-modal.component.css'],
  providers: [DatePipe]
 })
export class JobDescriptionModalComponent implements OnInit {
  file:any
  editJd:boolean=false;
  rowDataId:any=null;
  radiochecked:any=false;
  @Input() display: boolean;
  @Input() apiService: any;
  @Input() autoPopulateData:any;
  @Output() displayFunction = new EventEmitter<boolean>();
  @Output() getJDAndfile = new EventEmitter<object>();
  jobDescription: { jdName: any; jdDescription: string; };
  constructor(
    private _fileUploadService: FileUploadService,
    private _jobDescription: JobDescriptionService,
    private _toastService: MessageService,
    private _DatePipe:DatePipe,
    private _jdSearchService:JdSearchService,
    private _jobDescDocService: JobDescriptionDocumentService,
  ) { }
  @ViewChild('jobDescriptionForm',{static: false}) public jobDescriptionForm: NgForm;
  form: object = {};
  jdName: String;
  jdDescription: String;
  uploadedFile: File;
  uploadedFiles: any[] = [];
  newUploadedFile: FileUpload;//represents the newly uploaded file entity
  newJD: JobDescription;//represents the newly created JD entity
  jdAndFile: object = {};
  showCloseIcon: false;
  fileUrlDomain=Messages.endpoint.fileUrlDomain;
  showUploadError:boolean=false;
  cols:any;
  dtSelectedRows:any;
  rowSelected:any;
  specialAttribute:any;
  jdSearchResult:any=[];
  ngOnInit() {
    this.jobDescription={
      jdName:"",
      jdDescription:"",
      //jdFileUpload:null,
    };
    this.cols = [
      { field: 'select', header: 'SelectJD' },
      { field: 'name', header: 'JD Name' },
      { field: 'jdFileName', header: 'File Name' },
      { field: 'description', header: 'Description' },
      { field: 'actions', header: 'Actions' }
  ];
    if(!this.autoPopulateData.category && !this.autoPopulateData.technology) {
      this.display=false;
      this.displayFunction.emit(false);
      }else{
        this.callJdSearchService();
      }
  }
  callJdSearchService(){
    this.jobDescription.jdName=this.autoPopulateData.category.label +  '-' + this.autoPopulateData.technology.label;
    var jobSearchParam=this.autoPopulateData.category.value +  '/' + this.autoPopulateData.technology.value;
    this._jdSearchService.read(jobSearchParam,Messages.endpoint.jobDescription).subscribe(res => {
      this.jdSearchResult=res; 
      if(this.autoPopulateData.jd_id){
        this.setSelectedItem(this.autoPopulateData.jd_id);
      }
    });
  }
  showDialog(bool: boolean) {
    this.displayFunction.emit(bool);
  }
  editjd(editBool,rowdata?:any){
    this.showUploadError=false;
    this.uploadedFile=undefined;
    this.specialAttribute= rowdata ? rowdata.specialAttribute : '';
    if(!this.jdSearchResult[this.jdSearchResult.length-1].id){
      this.jdSearchResult.pop();
    }
    this.rowDataId= rowdata ? rowdata.id : '';
  }
  cancel(){
    this.rowDataId='';
  }
  uploadFiles(jobDescriptionForm,index,rowData) {
    //here we are going to create create the entry of this file into the database
    if(rowData.fileUrl && this.uploadedFile==undefined){
      let jd = new JobDescription();
            jd.id=rowData.id;
            jd.name = jobDescriptionForm.value &&  jobDescriptionForm.value.spclAttr? this.jobDescription.jdName + '-' + jobDescriptionForm.value.spclAttr : this.jobDescription.jdName;
            jd.description = jobDescriptionForm.value['jobDesc'+index] && jobDescriptionForm.value['jobDesc'+index]?jobDescriptionForm.value['jobDesc'+index] :'' ;
            jd.specialAttribute=jobDescriptionForm.value['spclAttr'+index]? jobDescriptionForm.value['spclAttr'+index] : '';
            jd.jobCategory=this.autoPopulateData.category.value;
            jd.technology=this.autoPopulateData.technology.value;
      this._jobDescription.editJob(jd).subscribe(
        res => {
          this.callJdSearchService();
          this._toastService.add({severity:'success', summary:Messages.jobDescriptionSuccessEdit, detail:''});
          this.rowDataId='';
          this.jobDescriptionForm.reset();
        }
      );
    }
    else if(this.uploadedFile==undefined){
      this.showUploadError=true;
    }
    else{
      this._fileUploadService.createFile(this.uploadedFile).subscribe(
        res => {
            console.log(res); this.newUploadedFile = res;
          //file is uploaded now create the job description
            let jd = new JobDescription();
            jd.name = jobDescriptionForm.value &&  jobDescriptionForm.value.spclAttr? this.jobDescription.jdName + '-' + jobDescriptionForm.value.spclAttr : this.jobDescription.jdName;
            jd.description = jobDescriptionForm.value['jobDesc'+index] && jobDescriptionForm.value['jobDesc'+index]?jobDescriptionForm.value['jobDesc'+index] :'' ;
            jd.specialAttribute=jobDescriptionForm.value['spclAttr'+index]? jobDescriptionForm.value['spclAttr'+index] : '';
            jd.jobCategory=this.autoPopulateData.category.value;
            jd.technology=this.autoPopulateData.technology.value;
            if(rowData.fileUrl){
              jd.previousFileUrl=rowData.fileUrl;
              jd.id=rowData.id;
              this._jobDescription.editJob(jd).subscribe(
                res => {
                  this.createJobDescriptionDocument(res);
                  this._toastService.add({severity:'success', summary:Messages.jobDescriptionSuccessEdit, detail:''});
                  this.rowDataId='';
                  this.jobDescriptionForm.reset();
                },(err) => {
                  this._toastService.add({severity:'error', summary:Messages.jobDescriptionError, detail:Messages.tryAgain
              })}
              );
            }else{
              this._jobDescription.create(jd).subscribe(
                res => {
                  this._toastService.add({severity:'success', summary:Messages.jobDescriptionSuccess, detail:''});
                  this.rowDataId='';
                  this.createJobDescriptionDocument(res);
                  this.jobDescriptionForm.reset();
                },(err) => {
                  if(typeof(err)=="string")
                  this._toastService.add({severity:'error', summary:err, detail:Messages.tryAgain})
                }
              );
            }
          
          }, (err) => {this._toastService.add({severity:'error', summary:Messages.jobDescriptionError, detail:Messages.tryAgain}); this.jobDescriptionForm.reset();

        }
      );
    }
   
  }
  selectRow(){
    if(this.dtSelectedRows){
      this.radiochecked=true;
    }else{
      this.radiochecked=false;
    }
    
  }
  createJobDescriptionDocument = function (res) {
    if (this.newUploadedFile.id !== undefined) {
      let jobDescDoc = new JobDescriptionDocument();
      jobDescDoc.file = this.newUploadedFile;
      jobDescDoc.jobDescription = res.id;    
      this._jobDescDocService.create(jobDescDoc).subscribe(res => { console.log(res);
        this.callJdSearchService();
       });
    }
  }
  onSelect(event,fileUpload) {
    //this.uploadedFiles = event.file;
    this.uploadedFile = event.files[0];
    if(this.uploadedFile==undefined){
      this.showUploadError=true;
    }else{
      this.showUploadError=false;
    }
    fileUpload.clear();
  }

  myUploader(event) {
    this.uploadedFile = event.files[0];
  }
  submitData(){
    if(this.dtSelectedRows && this.dtSelectedRows.id){
        this.jdAndFile['jd'] = this.dtSelectedRows;
        this.jdAndFile['file'] = this.newUploadedFile;
          // //emit both file and jd
          this.getJDAndfile.emit(this.jdAndFile);
          this.showDialog(false);
      }
  }
  onBasicUpload(event) {
    this.uploadedFile = event.file;
  }
  setSelectedItem(id){
    this.dtSelectedRows = this.jdSearchResult.filter(function(item) {
      return item.id == id;
    });
  }
  addNewRow(table){
    this.rowDataId='';
    this.uploadedFile = null;
    if(this.jdSearchResult &&this.jdSearchResult.length>0 && this.jdSearchResult[this.jdSearchResult.length-1].id || this.jdSearchResult.length==0){
      var newRow : any={
        id:'',
        name:this.autoPopulateData.category.label +  '-' + this.autoPopulateData.technology.label,
        description:'',
      }
      this.specialAttribute=this.autoPopulateData.specialAttribute;
      this.jdSearchResult.push(newRow);
    }
    let body = table.containerViewChild.nativeElement.getElementsByClassName("ui-table-scrollable-body")[0];
    setTimeout(function(){
      body.scrollTop = body.scrollHeight;
    },0) 
  }
}
